// Shared application palette. Keep literal colors usable by charts and PDF exports.
export const palette = {
  primary: '#594ad5', primaryHover: '#4839bf', primarySoft: '#f0edff',
  canvas: '#ffffff', surface: '#ffffff', subtle: '#f7f8fc',
  text: '#172238', muted: '#53627a', border: '#e2e7f0',
  success: '#07825e', warning: '#b76b08', error: '#d9363e', info: '#2563eb',
};
export const appTheme = {
  token: {
    colorPrimary: palette.primary, colorInfo: palette.info,
    colorSuccess: palette.success, colorWarning: palette.warning, colorError: palette.error,
    colorText: palette.text, colorTextSecondary: palette.muted,
    colorBgBase: palette.canvas, colorBgContainer: palette.surface,
    colorBgLayout: palette.canvas, colorBorder: palette.border,
    borderRadius: 10, borderRadiusLG: 16, borderRadiusSM: 8,
    controlHeight: 40, controlHeightLG: 48, controlHeightSM: 32,
    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 14, fontSizeHeading1: 32, fontSizeHeading2: 28, fontSizeHeading3: 24,
    lineHeight: 1.6, wireframe: false,
    boxShadow: '0 6px 24px rgba(23,34,56,.08)',
    boxShadowSecondary: '0 8px 32px rgba(23,34,56,.10)',
  },
  components: {
    Button: { primaryShadow: '0 2px 6px rgba(89,74,213,.16)', fontWeight: 600 },
    Card: { headerFontSize: 16, headerHeight: 56, paddingLG: 24 },
    Table: { headerBg: palette.subtle, headerColor: palette.muted, rowHoverBg: '#f6f5ff', borderColor: palette.border, cellPaddingBlock: 14, cellPaddingInline: 16 },
    Tabs: { titleFontSize: 14, itemSelectedColor: palette.primary, inkBarColor: palette.primary },
    Menu: { itemSelectedBg: palette.primarySoft, itemSelectedColor: palette.primary, itemBorderRadius: 10, itemHeight: 42 },
    Modal: { contentBg: palette.surface, headerBg: palette.surface, titleColor: palette.text, borderRadiusLG: 16 },
    Drawer: { colorBgElevated: palette.surface },
    Input: { activeBorderColor: palette.primary, hoverBorderColor: '#9b91e8' },
    Select: { optionSelectedBg: palette.primarySoft },
  },
};
